import React from 'react';
import './article.css';

const Article = ({ imgUrl, date, text, paragraph }) => (
  <div className="gpt3__blog-container_article">
    <div className="gpt3__blog-container_article-image">
      <img src={imgUrl} alt="blog_image" />
    </div>
    <div className="gpt3__blog-container_article-content">
      <div>
        <p>{date}</p>
        <h3>{text}</h3>
        <p style={{ fontSize: '1rem' }}>{paragraph}</p>
      </div>
      <p style={{ color: '#63dbfa' }}>Read Full Article</p>
    </div>
  </div>
);

export default Article;
